import { Component, OnInit, ViewChild } from '@angular/core';
import { DocumentLibraryConstants } from '../document-library-constants';
import { DocumentService } from '../services/document.service';
import { LabelConstants } from '../../shared/constants/label-constants';
import { DocumentSearchResult } from '../models/documentSearchResult';
import { DocumentLibrarySearchComponent } from '../../document-search/document-library-search/document-library-search.component';

@Component({
  selector: 'app-document-library',
  templateUrl: './document-library.component.html',
  styleUrls: ['./document-library.component.scss']
})
export class DocumentLibraryComponent implements OnInit {
  
  @ViewChild('librarySearch')
  librarySearchComponent!: DocumentLibrarySearchComponent;
 
  isDocumentSliderOpen = false;
  topBarTitle:string = DocumentLibraryConstants.DocumentLibraryTitle;
  isScreenAccessible : boolean = true;
  errorMessage !: string;
  documentLookUpData:any;
  documentLibraryScreen = DocumentLibraryConstants.DocumentLibraryScreen;
  isBulkSliderOpen : boolean = false;
  enableToaster: boolean = false;
  showSpinner: boolean = false;

  constructor(private documentService : DocumentService) { }

  ngOnInit(): void {
    this.documentService.getDocumentdetails().subscribe({
      error: (err) => {
        if(err.status === LabelConstants.Forbidden_StatusCode){
          this.errorMessage=err.error.detail;
        }
         this.isScreenAccessible = false
      },
      next:(serviceData)=>this.documentLookUpData = serviceData
    })
  }
  
  addDocument() : void{
    this.isDocumentSliderOpen = !this.isDocumentSliderOpen;
  }
  
  closeDocumentSlider(isSliderActive : boolean){
    this.isDocumentSliderOpen = isSliderActive;
  }

  bulkUserReplacement(){
    this.isBulkSliderOpen = !this.isBulkSliderOpen;
  }

  closeBulkUserReplacementSlider(isSliderActive: boolean){
    this.isBulkSliderOpen = isSliderActive;
  }

  onClearSelectionsRequested(): void {
    // Clear all selections after bulk user replacement
    this.librarySearchComponent?.clearSelectionsAfterBulkOperation();
  }

}
